// Notes belong to the lead, so a lead with more than one event shows every event's notes; this says where each came from
export function noteOrigin(note) {
    if (!note.event_id) return 'Lead stage'
    const event = note.event
    return event ? `Event ${event.reference_code || event.name || '#' + event.id}` : `Event #${note.event_id}`
}
